/* eslint-disable */
import React from 'react'
import styled from 'styled-components'
import { useTranslation } from "react-i18next"

const AboutSidebarStyle = styled.menu`
  padding: 0;
  margin: 0;
  width: 100%;
  display: flex;
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    width: 100%;
    display: flex;
    flex-direction: column;
    border: solid 1px #dcdcdc;
    > li {
      margin: 0;
      padding: 0;
      cursor: pointer;
      display: flex;
      width: 100%;
        justify-content: space-between;
        align-items: center;
        padding: 10px 24px;
        width: 100%;
        display: flex;
        text-decoration: none;
        background: #fff;
        font-family: 'Open Sans', sans-serif;
        font-size: 14px;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #191919;
        transition: all 0.3s ease-in;
        path:last-child {
          fill: #ff7400;
          transition: all 0.3s ease-in;
        }
        &:hover {
          color: #ff7400;
        }
        &.active {
          background: linear-gradient(to left, #ff9700, #ff7400);
          color: #fff;
          transition: all 0.3s ease-in;
          path:last-child {
            transition: all 0.3s ease-in;
            fill: #fff;
          }
        }
      
    }
  }
`

const ArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="17"
      viewBox="0 0 7 17"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M-9-6h24v24H-9z" />
        <path
          fillRule="nonzero"
          d="M1.238 0l5.17 5.805L7 6.5l-.592.695L1.238 13 0 11.61 4.55 6.5 0 1.39z"
        />
      </g>
    </svg>
  )
}

const scrollToFunction = (target) => {
  let targetOffset = document.getElementById(target).offsetTop - 85;
  window.scrollTo(0, targetOffset);
  document.getElementById(target).click();
}

const SidebarPrivacyPolicy = () => {
  const { t } = useTranslation()
  const DataSidebar = [
    {
      id: 'privacy-1',
      title: t('pagePrivacyPolicy.part1'),
      targetScroll: 'privacy-1'
    },
    {
      id: 'privacy-2',
      title: t('pagePrivacyPolicy.part3'),
      targetScroll: 'privacy-2'
    },
    {
      id: 'privacy-3',
      title: t('pagePrivacyPolicy.part5'),
      targetScroll: 'privacy-3'
    },
    {
      id: 'privacy-4',
      title: t('pagePrivacyPolicy.part7'),
      targetScroll: 'privacy-4'
    },
    {
      id: 'privacy-5',
      title: t('pagePrivacyPolicy.part9'),
      targetScroll: 'privacy-5'
    },
    {
      id: 'privacy-6',
      title: t('pagePrivacyPolicy.part11'),
      targetScroll: 'privacy-6'
    },
    {
      id: 'privacy-7',
      title: t('pagePrivacyPolicy.part13'),
      targetScroll: 'privacy-7'
    },
    {
      id: 'privacy-8',
      title: t('pagePrivacyPolicy.part15'),
      targetScroll: 'privacy-8'
    },
    {
      id: 'privacy-9',
      title: t('pagePrivacyPolicy.part17'),
      targetScroll: 'privacy-9'
    },
    {
      id: 'privacy-10',
      title: t('pagePrivacyPolicy.part19'),
      targetScroll: 'privacy-10'
    },
    {
      id: 'privacy-11',
      title: t('pagePrivacyPolicy.part21'),
      targetScroll: 'privacy-11'
    },
    {
      id: 'privacy-12',
      title: t('pagePrivacyPolicy.part23'),
      targetScroll: 'privacy-12'
    }
  ]
  return (
    <AboutSidebarStyle>
      <ul>
        {DataSidebar.map((value, index) => {
          return (
            <li onClick={() => scrollToFunction(value.targetScroll)} key={`privary-title-${index}`}>
              {value.title}
              {/* <ArrowIcon></ArrowIcon> */}
            </li>
          )
        })}
      </ul>
    </AboutSidebarStyle>
  )
}

export default SidebarPrivacyPolicy
